import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import DashboardPage from "../pages/Dashboard/Dashboard";

export const MainContext = React.createContext({
  user: {},
});

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
      user: {},
    };
  }

  // componentWillMount() {
  //   this.getUser();
  // }

  // getUser = async () => {
  //   const user = JSON.parse(localStorage.getItem("user"));
  //   let { data } = await ApiCall.getUser(user.id);
  //   if (data) this.setState({ user: data });
  // };

  render() {
    const { user } = this.state;
    return (
      <MainContext.Provider value={{ user }}>
        <DashboardPage />
        {/* <div className="main-dashboard-container">
          <DashBoardRoute />
        </div> */}
      </MainContext.Provider>
    );
  }
}

export default withRouter(Dashboard);
